import cover from '../../assets/images/img_calendario/cover.jpg'        
import gennaio from '../../assets/images/img_calendario/gennaio.jpg'
import febbraio from '../../assets/images/img_calendario/febbraio.jpg'
import marzo from '../../assets/images/img_calendario/marzo.jpg'
import aprile from '../../assets/images/img_calendario/aprile.jpg'
import maggio from '../../assets/images/img_calendario/maggio.jpg'
import giugno from '../../assets/images/img_calendario/giugno.jpg'
import luglio from '../../assets/images/img_calendario/luglio.jpg'
import agosto from '../../assets/images/img_calendario/agosto.jpg'
import settembre from '../../assets/images/img_calendario/settembre.jpg'
import ottobre from '../../assets/images/img_calendario/ottobre.jpg'
import novembre from '../../assets/images/img_calendario/novembre.jpg'
import dicembre from '../../assets/images/img_calendario/dicembre.jpg'

import coverMobile from '../../assets/images/img_calendario/cover_mb.jpg'        
import gennaioMobile from '../../assets/images/img_calendario/gennaio_mb.jpg'
import febbraioMobile from '../../assets/images/img_calendario/febbraio_mb.jpg'
import marzoMobile from '../../assets/images/img_calendario/marzo_mb.jpg'
import aprileMobile from '../../assets/images/img_calendario/aprile_mb.jpg'
import maggioMobile from '../../assets/images/img_calendario/maggio_mb.jpg'
import giugnoMobile from '../../assets/images/img_calendario/giugno_mb.jpg'
import luglioMobile from '../../assets/images/img_calendario/luglio_mb.jpg'
import agostoMobile from '../../assets/images/img_calendario/agosto_mb.jpg'
import settembreMobile from '../../assets/images/img_calendario/settembre_mb.jpg'
import ottobreMobile from '../../assets/images/img_calendario/ottobre_mb.jpg'
import novembreMobile from '../../assets/images/img_calendario/novembre_mb.jpg'
import dicembreMobile from '../../assets/images/img_calendario/dicembre_mb.jpg'

const elementInside = [
  { 
    color: '#c70410', 
    photo: marzo,
    photoM:marzoMobile,
    name: {
      it: "marzo",
      en: "march"
    }
  }, 
  { 
    color: '#ce0800', 
    photo: agosto,
    photoM: agostoMobile,
    name: {
        it: "agosto",
        en: "august"
    } 
  }, 
  { 
    color: '#dd2700', 
    photo: cover,
    photoM: coverMobile,
    name: {
      it: "cover",
      en: "cover"
    }
  }, 
  { 
    color: '#dc3500', 
    photo: giugno,
    photoM: giugnoMobile,
    name: {
      it: "giugno",
      en: "june"
   }
  }, 
  { 
    color: '#dc4600', 
    photo: aprile,
    photoM: aprileMobile,
    name: {
      it: "aprile",
      en: "april"
    }
  }, 
  { 
    color: '#dc5600', 
    photo: maggio,
    photoM: maggioMobile,
    name: {
      it: "maggio",
      en: "may"
    }
  }, 
  { 
    color: '#dc6500',
    photo: settembre,
    photoM: settembreMobile,
    name: {
        it: "settembre",
        en: "september"
    }
  }, 
  { 
    color: '#dc7601', 
    photo: agosto,
    photoM: agostoMobile,
    name: {
        it: "agosto",
        en: "august"
    }
  }, 
  { 
    color: '#dc8700',
     photo: dicembre,
     photoM: dicembreMobile,
     name: {
         it: "dicembre",
         en: "december"
     } 
  }, 
  { 
    color: '#db9900', 
    photo: ottobre,
    photoM: ottobreMobile,
    name: {
        it: "ottobre",
        en: "october"
    } 
  }, 
  { 
    color: '#dcab00',
    photo: giugno,
    photoM: giugnoMobile,
    name: {
      it: "giugno",
      en: "june"
   }
  }, 
  { 
    color: '#dbbc00', 
    photo: luglio,
    photoM: luglioMobile,
    name: {
        it: "luglio",
        en: "july"
    }
  }, 
  { 
    color: '#dccd00',
    photo: agosto,
    photoM: agostoMobile,
    name: {
        it: "agosto",
        en: "august"
    } 
  }, 
  { 
    color: '#cad700',
    photo: febbraio,
    photoM: febbraioMobile,
    name: {
      it: "febbraio",
      en: "february"
  }
  }, 
  { 
    color: '#acd700', 
    photo: novembre,
    photoM: novembreMobile,
    name: {
        it: "novembre",
        en: "november"
    }
  }, 
  { 
    color: '#8bd901', 
    photo: aprile,
    photoM: aprileMobile,
    name: {
      it: "aprile",
      en: "april"
    }
  }, 
  { 
    color: '#6cd901', 
    photo: giugno,
    photoM: giugnoMobile,
    name: {
      it: "giugno",
      en: "june"
    }
  }, 
  { 
    color: '#4ad802',
    photo: gennaio,
    photoM: gennaioMobile,
    name: {
      it: "gennaio",
      en: "january"
    }
  }, 
  { 
    color: '#2ad700',
    photo: febbraio,
    photoM: febbraioMobile,
    name: {
      it: "febbraio",
      en: "february"
    }
  }, 
  { 
    color: '#07d50a',
    photo: novembre,
    photoM: novembreMobile,
    name: {
        it: "novembre",
        en: "november"
    }
  }, 
  { 
    color: '#08d72f',
    photo: luglio,
    photoM: luglioMobile,
    name: {
        it: "luglio",
        en: "july"
    }
  }, 
  { 
    color: '#09db46', 
    photo: maggio,
    photoM: maggioMobile,
    name: {
      it: "maggio",
      en: "may"
    }
  }, 
  { 
    color: '#07d966',
    photo: marzo,
    photoM: marzoMobile,
    name: {
      it: "marzo",
      en: "march"
    } 
  }, 
  { 
    color: '#04d98b', 
    photo: giugno,
    photoM: giugnoMobile,
    name: {
      it: "giugno",
      en: "june"
    }
  }, 
  { 
    color: '#03d9ab',
    photo: ottobre,
    photoM: ottobreMobile,
    name: {
        it: "ottobre",
        en: "october"
    }
  }, 
  { 
    color: '#01d9ce',
    photo: cover,
    photoM: coverMobile,
    name: {
      it: "cover",
      en: "cover"
    }
  }, 
  { 
    color: '#00d1dc',
    photo: novembre,
    photoM: novembreMobile,
    name: {
        it: "novembre",
        en: "november"
    }
  }, 
  { 
    color: '#00c2dc',
    photo: luglio,
    photoM: luglioMobile,
    name: {
        it: "luglio",
        en: "july"
    }
  }, 
  { 
    color: '#00b3dc',
    photo: agosto,
    photoM: agostoMobile,
    name: {
        it: "agosto",
        en: "august"
    }
  }, 
  { 
    color: '#00a6dc',
    photo: settembre,
    photoM: settembreMobile,
    name: {
        it: "settembre",
        en: "september"
    } 
  }, 
  { 
    color: '#0097dc',
    photo: gennaio,
    photoM: gennaioMobile,
    name: {
      it: "gennaio",
      en: "january"
    }
  }, 
  { 
    color: '#0088dc',
    photo: cover,
    photoM: coverMobile,
    name: {
      it: "cover",
      en: "cover"
    }
  }, 
  { 
    color: '#007bdc',
    photo: aprile,
    photoM: aprileMobile,
    name: {
      it: "aprile",
      en: "april"
    }
  }, 
  { 
    color: '#0568cf ',
    photo: dicembre,
    photoM: dicembreMobile,
    name: {
        it: "dicembre",
        en: "december"
    }
  },
  { 
    color: '#0b55c0',
    photo: maggio,
    photoM: maggioMobile,
    name: {
      it: "maggio",
      en: "may"
    }
  }, 
  { 
    color: '#1043b6',
    photo: marzo,
    photoM: marzoMobile,
    name: {
      it: "marzo",
      en: "march"
    }
  }, 
  { 
    color: '#1430a8',
    photo: ottobre,
    photoM: ottobreMobile,
    name: {
        it: "ottobre",
        en: "october"
    } 
  }, 
  { 
    color: '#181f9a',
    photo: settembre,
    photoM: settembreMobile,
    name: {
        it: "settembre",
        en: "september"
    } 
  }, 
  { 
    color: '#1c0e8f',
    photo: febbraio,
    photoM: febbraioMobile,
    name: {
      it: "febbraio",
      en: "february"
    }
  }, 
  { 
    color: '#340d93', 
    photo: novembre,
    photoM: novembreMobile,
    name: {
        it: "novembre",
        en: "november"
    } 
  }, 
  {
    color: '#5a18a3',
    photo: luglio,
    photoM: luglioMobile,
    name: {
        it: "luglio",
        en: "july"
    } 
  }, 
  { 
    color: '#7b22b2',
    photo: marzo,
    photoM: marzoMobile,
    name: {
      it: "marzo",
      en: "march"
    }
  }, 
  { 
    color: '#952bbd',
    photo: settembre,
    photoM: settembreMobile,
    name: {
        it: "settembre",
        en: "september"
    } 
  }, 
  { 
    color: '#b237ca',
    photo: gennaio,
    photoM: gennaioMobile,
    name: {
      it: "gennaio",
      en: "january"
    }
  }, 
  { 
    color: '#c842d5',
    photo: dicembre,
    photoM: dicembreMobile,
    name: {
        it: "dicembre",
        en: "december"
    }
  }, 
  { 
    color: '#d949d9', 
    photo: aprile,
    photoM: aprileMobile,
    name: {
      it: "aprile",
      en: "april"
    }
  }, 
  { 
    color: '#dc3ec1', 
    photo: cover,
    photoM: coverMobile,
    name: {
      it: "cover",
      en: "cover"
    }
  }, 
  { 
    color: '#da33a4', 
    photo: ottobre,
    photoM: ottobreMobile,
    name: {
        it: "ottobre",
        en: "october"
    }
  }, 
  { 
    color: '#da2786',
    photo: maggio,
    photoM: maggioMobile,
    name: {
      it: "maggio",
      en: "may"
    }
  }, 
  { 
    color: '#db1b61', 
    photo: dicembre,
    photoM: dicembreMobile,
    name: {
        it: "dicembre",
        en: "december"
    } 
  }, 
  { 
    color: '#db1039', 
    photo: gennaio,
    photoM: gennaioMobile,
    name: {
      it: "gennaio",
      en: "january"
    }
  }, 
  { 
    color: '#dc040f', 
    photo: febbraio,
    photoM: febbraioMobile,
    name: {
      it: "febbraio",
      en: "february"
    }
  }
];

export default elementInside